import { motion } from "framer-motion"
import { MenuIcon, ShieldAlert } from "lucide-react"
import Logo from "@/shared/assets/images/logo.svg"

export default function GlobalErrorPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white text-gray-800">
      {/* Sidebar */}
      <div className="min-h-screen grayscale">
        <aside className="fixed top-0 left-0 h-full w-[319px] border-gray-300 border-r bg-blue-500 p-6">
          <div className="sidebar__header-logo flex items-center">
            <img src={Logo} width={48} alt="Логотип Энергосам" className="transition-all" />
            <div className="header-titles transition-all">
              <strong className="text-nowrap text-base uppercase">Энергоэффективность</strong>
              <p className="text-nowrap text-sm">Система энергетического контроля</p>
            </div>
          </div>
          <ul className="space-y-3 p-3 text-sm">
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Мониторинг
            </li>
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Карта
            </li>
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Управление
            </li>
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Настройки
            </li>
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Настройки
            </li>
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Настройки
            </li>
            <li className="flex cursor-pointer items-center gap-2 rounded-lg bg-gray-400 px-4 py-3 text-white hover:underline">
              <MenuIcon /> Настройки
            </li>
          </ul>
        </aside>

        {/* Topbar */}
        <header className="sticky top-0 z-10 ml-[319px] flex h-16 items-center justify-between border-gray-300 border-b bg-gray-100 px-6">
          <div className="font-semibold">Добро пожаловать, Админ</div>
          <div className="text-gray-500 text-sm">admin@govsite.gov</div>
        </header>

        {/* Main Content (Table Skeleton) */}
        <main className="mt-4 ml-[319px] px-6">
          <h2 className="mb-4 font-semibold text-xl">Отчёты пользователей</h2>
          <div className="overflow-hidden rounded-lg border border-gray-300">
            <div className="grid grid-cols-4 border-gray-300 border-b bg-gray-100 p-3 font-medium text-sm">
              <div>Имя</div>
              <div>Эл. почта</div>
              <div>Статус</div>
              <div>Дата</div>
            </div>
            {Array.from({ length: 6 }).map((_, idx) => (
              <div key={idx} className="grid animate-pulse grid-cols-4 border-gray-200 border-b p-3 text-gray-400 text-sm">
                <div className="h-4 w-3/4 rounded bg-gray-300" />
                <div className="h-4 w-5/6 rounded bg-gray-300" />
                <div className="h-4 w-1/2 rounded bg-gray-300" />
                <div className="h-4 w-2/3 rounded bg-gray-300" />
              </div>
            ))}
          </div>
        </main>
      </div>

      {/* Error Overlay */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="absolute inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
      >
        <div className="w-full max-w-md rounded-2xl border border-red-200 bg-white p-10 text-center shadow-2xl dark:bg-gray-900">
          <div className="mb-4 text-red-600">
            <ShieldAlert size={48} />
          </div>
          <h1 className="mb-2 font-bold text-2xl">Системная ошибка</h1>
          <p className="text-gray-600 dark:text-gray-300">Произошла ошибка.</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-6 rounded-lg bg-red-600 px-5 py-2 font-medium text-sm text-white hover:bg-red-700"
          >
            Перезагрузить страницу
          </button>
        </div>
      </motion.div>
    </div>
  )
}
